import isNil from 'lodash/isNil';

export class GameAnalytic {
  id: number;

  name: string;

  startDateTime: Date;

  country: string;

  point: number;

  time: number;

  completed: boolean;

  gameId: number;

  rating: number;

  constructor(model: any) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.startDateTime = model.startDateTime || null;
    this.country = model.country || null;
    this.point = !isNil(model.point) ? model.point : null;
    this.time = !isNil(model.time) ? model.time : null;
    this.completed = model.completed || false;
    this.gameId = model.gameId || null;
    this.rating = !isNil(model.rating) ? model.rating : null;
  }
}
